<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <NavbarLayout />
  <SidebarLayout v-if="userData != null" />
  <v-main id="content">
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Info Kontraktor
        </h2>
        <p class="text-gray-500">
          Temukan Informasi Publik Seputar Kontraktor disini
        </p>
        <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
          <v-col cols="4">
            <v-text-field
              variant="outlined"
              density="compact"
              color="red"
              hide-details
              clearable
              v-model="formValues.keyword"
              v-on:keyup.enter="cariKontraktor"
              @click:clear="onClearKeyword"
              prepend-inner-icon="mdi-magnify"
              placeholder="Masukkan Nama Kontraktor"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              prepend-icon="mdi-filter"
              class="w-full bg-slate-50 text-slate-600 capitalize"
            >
              Cari Berdasarkan
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              class="bg-red-600 w-full text-white capitalize"
              @click="cariKontraktor()"
            >
              Cari Kontraktor
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <div class="my-8 rounded-lg shadow-md overflow-x-auto w-full">
        <v-data-table-server
          v-model:page="dataTable.pagination.page"
          v-model:items-per-page="dataTable.pagination.itemsPerPage"
          :items-per-page-options="[5, 10, 25, 50, 100]"
          :headers="dataTable.headers"
          :items="dataTable.items"
          :loading="dataTable.loading"
          :items-length="dataTable.pagination.totalItems"
          @update:options="fetchData"
        >
          <template v-slot:item="{ item, index }">
            <tr
              class="border-b border-gray-950 h-16"
              :class="{ 'bg-gray-50': index % 2 !== 0 }"
            >
              <td>
                <div
                  class="mix-blend-multiply"
                  @click="redirectToLink('/detailkontraktor/', item.id)"
                >
                  <img
                    src="../assets/images/search.png"
                    alt=""
                    class="min-w-5 w-5 h-auto cursor-pointer"
                  />
                </div>
              </td>
              <td class="text-nowrap">
                {{ item.namaKontraktor }}
              </td>
              <td class="text-nowrap">
                {{ item.inisial }}
              </td>
              <td class="text-nowrap">
                <div class="flex items-center gap-2 text-nowrap">
                  <span v-if="!item.workArea || item.workArea.length === 0"
                    >-</span
                  >
                  <span v-else class="flex items-center gap-2">
                    <template
                      v-for="(area, idx) in parseWorkArea(item.workArea)"
                      :key="idx"
                    >
                      <img
                        v-if="area === 'BIB'"
                        src="../assets/icon/mining-red.png"
                        alt="BIB"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else-if="area === 'Mining'"
                        src="../assets/icon/mining-black.png"
                        alt="Mining"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else-if="area === 'Hauling'"
                        src="../assets/icon/truck-orange.png"
                        alt="Hauling"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else-if="area === 'Port'"
                        src="../assets/icon/Harbor.png"
                        alt="Port"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else-if="area === 'Project'"
                        src="../assets/icon/hat-orange.png"
                        alt="Project"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else-if="area === 'ROM'"
                        src="../assets/icon/ROM.png"
                        alt="Project"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <img
                        v-else
                        src="../assets/icon/others.png"
                        alt="Others"
                        class="mix-blend-multiply min-w-7 w-7 h-auto"
                      />
                      <span>{{ area }}</span>
                    </template>
                  </span>
                </div>
              </td>
              <td class="text-wrap">
                <span class="font-bold">
                  {{
                    item.isMainKontraktor ? "Main Kontraktor" : "Subkontraktor"
                  }} </span
                ><br />
                <div
                  v-if="item.dataSubkontraktor"
                  class="mt-1 bg-cyan-accent-1 text-black text-sm rounded px-2 py-1 inline-block"
                >
                  Subkontraktor: {{ item.dataSubkontraktor }}
                </div>
              </td>
              <td class="text-nowrap">{{ item.kualifikasiUsaha }}</td>
              <td class="text-wrap">{{ item.alamat }}</td>
              <td>
                <div class="flex items-center gap-2 text-nowrap">
                  <span class="flex">NIB : </span>
                  <span class="flex">
                    {{ item.noNib == null ? "-" : item.noNib }}
                  </span>
                </div>
                <div class="flex items-center gap-2 text-nowrap">
                  <span class="flex">IUJP : </span>
                  <span class="flex">
                    {{ item.noIujp == null ? "-" : item.noIujp }}
                  </span>
                </div>
              </td>
              <td class="text-nowrap">{{ item.jenis }}</td>
              <td class="capitalize text-nowrap">
                <div
                  class="px-1 rounded-md flex items-center gap-2 w-fit"
                  :class="{
                    'bg-[#ffe5e5] text-[#dd3737]':
                      item.tingkatResiko === 'Tinggi',
                    'bg-[#f4eadb] text-[#ff8800]':
                      item.tingkatResiko === 'Sedang',
                    'bg-[#ddfbec] text-[#0c8953]':
                      item.tingkatResiko === 'Rendah',
                    'bg-[#c8bde0] text-[#720c89]':
                      item.tingkatResiko === 'Kritis',
                  }"
                >
                  <i
                    class="mdi mdi-circle text-[8px]"
                    v-if="
                      ['Tinggi', 'Sedang', 'Rendah', 'Kritis'].includes(
                        item.tingkatResiko,
                      )
                    "
                  ></i>
                  <span class="font-semibold">{{ item.tingkatResiko }}</span>
                </div>
              </td>
              <td class="text-nowrap">
                {{ item.nilaiPraKplh }}
              </td>
              <td class="text-nowrap">
                {{
                  item.tanggalBerakhir
                    ? moment(item.tanggalBerakhir).format("DD/MMM/YYYY")
                    : "-"
                }}
              </td>
              <td class="text-nowrap">{{ item.wilayah }}</td>
              <td class="text-nowrap">
                {{
                  item.tglExpIujp == null
                    ? "-"
                    : moment(item.tglExpIujp).format("DD/MMM/YYYY")
                }}
              </td>
              <td class="text-nowrap">
                {{ item.nilaiPredikat }}
                <span v-if="item.predikat == 'HIJAU'" class="text-success">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span
                  v-else-if="item.predikat == 'EMAS'"
                  style="color: #e19140"
                >
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span
                  v-else-if="item.predikat == 'BIRU'"
                  style="color: #326bd5"
                >
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span
                  v-else-if="item.predikat == 'HITAM'"
                  style="color: #171716"
                >
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
                <span v-else-if="item.predikat == 'MERAH'" class="text-danger">
                  <font-awesome-icon icon="fa-solid fa-square" style="" />
                </span>
              </td>
              <td class="text-nowrap">{{ item.namaPjo }}</td>
              <td class="text-nowrap">
                {{ item.kompetensiPjo }}
              </td>
              <td class="text-nowrap">{{ item.picName }}</td>
              <td class="text-nowrap">{{ item.picEmail }}</td>
            </tr>
          </template>
        </v-data-table-server>
      </div>
    </v-row>
  </v-main>
  <FooterLayout />
  <!-- modal filter -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body font-inter">
          <!-- <p>Modal body text goes here.</p> -->
          <div class="d-flex justify-content-end w-100">
            <button
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="izinKerja" class="form-label fs-8 fw-bold"
                >Izin Kerja</label
              >
              <input
                type="text"
                class="form-control fs-9"
                id="izinKerja"
                placeholder="Masukkan Nomor Izin Kerja"
                v-model="formValues.izinKerja"
              />
            </div>
            <div class="col-md-6">
              <label for="nilai_pra_kplh" class="form-label fs-8 fw-bold"
                >Nilai Prakualifikasi</label
              >
              <input
                type="text"
                class="form-control fs-9"
                id="nilai_pra_kplh"
                placeholder="Masukkan Nilai"
                v-model="formValues.nilaiPraKplh"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold">Jenis</label>
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="inti"
                    id="jenis_inti"
                    v-model="formValues.jenis"
                  />
                  <label class="form-check-label fs-9" for="jenis_inti">
                    Inti
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="non_inti"
                    id="jenis_non_inti"
                    v-model="formValues.jenis"
                  />
                  <label class="form-check-label fs-9" for="jenis_non_inti">
                    Non Inti
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-1">
                <label for="wilayah" class="form-label fs-8 fw-bold"
                  >Wilayah</label
                >
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="lokal"
                    id="wilayah_lokal"
                    v-model="formValues.wilayah"
                  />
                  <label class="form-check-label fs-9" for="wilayah_lokal">
                    Lokal
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="non_lokal"
                    id="wilayah_non_lokal"
                    v-model="formValues.wilayah"
                  />
                  <label class="form-check-label fs-9" for="wilayah_non_lokal">
                    Non Lokal
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="">
                <label for="kode_kbli" class="form-label fs-8 fw-bold"
                  >Kode KBLI</label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="kode_kbli"
                  placeholder="Masukkan Kode KBLI"
                  v-model="formValues.kbli"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="">
                <label for="keyword_kbli" class="form-label fs-8 fw-bold"
                  >Keyword KBLI</label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="keyword_kbli"
                  placeholder="Masukkan Keyword KBLI"
                  v-model="formValues.keywordKbli"
                />
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="mb-1">
                <label for="jenis" class="form-label fs-8 fw-bold"
                  >Kompetensi</label
                >
              </div>
              <div class="d-flex">
                <div class="form-check" style="margin-right: 1rem">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="pou"
                    id="komp_pou"
                    v-model="formValues.kompetensi"
                  />
                  <label class="form-check-label fs-9" for="komp_pou">
                    POU
                  </label>
                </div>
                <div class="form-check" style="margin-right: 1rem">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="pop"
                    id="komp_pop"
                    v-model="formValues.kompetensi"
                  />
                  <label class="form-check-label fs-9" for="komp_pop">
                    POP
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="pom"
                    id="komp_pom"
                    v-model="formValues.kompetensi"
                  />
                  <label class="form-check-label fs-9" for="komp_pom">
                    POM
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="nama_pjo" class="form-label fs-8 fw-bold"
                >Nama PJO</label
              >
              <input
                type="text"
                class="form-control fs-9"
                id="nama_pjo"
                placeholder="Masukkan Nama PJO"
                v-model="formValues.namaPjo"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="">
                <label for="bidang" class="form-label fs-8 fw-bold"
                  >Bidang</label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="keyword_bidang"
                  placeholder="Masukkan Bidang"
                  v-model="formValues.bidang"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="">
                <label for="subBidang" class="form-label fs-8 fw-bold"
                  >Sub Bidang</label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="keyword_subbidang"
                  placeholder="Masukkan Sub bidang"
                  v-model="formValues.subbidang"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
          <button class="btn btn_cari w-100 fs-8 fw-bold" @click="terapkan">
            Terapkan
          </button>
          <button class="btn btn_refresh w-100 fs-8 fw-bold" @click="refresh">
            Refresh Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
:deep(table) {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100%;
}

:deep(thead) {
  background-color: #fecaca;
}

.pointer {
  cursor: pointer;
}

.fs-7 {
  font-size: 0.9rem !important;
}

.fs-8 {
  font-size: 0.8rem !important;
}

.fs-9 {
  font-size: 0.7rem !important;
}

.fs-10 {
  font-size: 0.6rem !important;
}

.fs-11 {
  font-size: 0.5rem !important;
}

.fs-12 {
  font-size: 0.4rem !important;
}

.fs-13 {
  font-size: 0.3rem !important;
}

#text_info_kontraktor {
  color: #dd3737;
  font-family: "Inter-Medium";
  font-style: normal;
  font-weight: bold;
  font-size: 2.5rem;
  /* line-height: 54px; */
}

#subtitle_info_kontraktor {
  color: #555770;
  font-family: "Inter-Regular";
  font-size: 1rem;
}

.btn_cari {
  background: #dd3737 !important;
  color: #ffffff !important;
}

.btn_refresh {
  background: #eeecec !important;
  color: #f35656 !important;
}
</style>

<script>
import axios from "axios";
import GlobalDataMixin from "../GlobalDataMixin";
import { API_BASE_URL, CMS_GET_LISTKONTRAKTOR } from "../constants.js";
import NavbarLayout from "@/layouts/NavbarLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import SidebarLayout from "@/layouts/SidebarLayout.vue";
import FooterLayout from "@/layouts/FooterLayout.vue";
// import SidebarComponent from "@/components/SideBar.vue";

const url = API_BASE_URL + CMS_GET_LISTKONTRAKTOR;

export default {
  mixins: [GlobalDataMixin],
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "", align: "start", sortable: false, width: "3%" },
        {
          title: "Nama Kontraktor",
          key: "kontraktor_name",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          title: "Inisial",
          key: "inisial",
          align: "start",
          sortable: true,
          width: "10%",
        },
        {
          title: "Work Area",
          key: "work_area",
          align: "start",
          sortable: true,
          width: "5%",
        },
        {
          title: "Status",
          key: "status",
          align: "start",
          sortable: false,
          width: "15%",
        },
        {
          title: "Kualifikasi Usaha",
          key: "kualifikasi_usaha",
          align: "start",
          sortable: false,
          width: "10%",
        },
        {
          title: "Alamat Kontraktor",
          key: "alamat",
          align: "start",
          sortable: true,
          width: "20%",
        },
        {
          title: "Izin Kerja",
          key: "nib",
          align: "start",
          sortable: true,
          width: "8%",
        },
        {
          title: "Jenis",
          key: "jenis",
          align: "start",
          sortable: true,
          width: "5%",
        },
        {
          title: "Tingkat Resiko",
          key: "tingkat_resiko",
          align: "start",
          sortable: true,
          width: "7%",
        },
        {
          title: "Nilai Prakualifikasi",
          key: "pra_kplh",
          align: "start",
          sortable: true,
          width: "7%",
        },
        {
          title: "Tanggal Berakhir Pra KPLH",
          align: "start",
          sortable: false,
          width: "7%",
        },
        {
          title: "Wilayah",
          key: "wilayah",
          align: "start",
          sortable: true,
          width: "7%",
        },
        {
          title: "Masa Aktif IUJP",
          key: "iujp_exp",
          align: "start",
          sortable: true,
          width: "8%",
        },
        {
          title: "Nilai Predikat",
          key: "nilai_predikat",
          align: "start",
          sortable: false,
          width: "10%",
        },
        { title: "Nama PJO", align: "start", sortable: false, width: "7%" },
        { title: "Kompetensi", align: "start", sortable: false, width: "7%" },
        {
          title: "PIC Name",
          key: "picName",
          align: "start",
          sortable: true,
          width: "7%",
        },
        {
          title: "PIC Email",
          key: "picEmail",
          align: "start",
          sortable: true,
          width: "7%",
        },
      ]),
      kontraktors: [],
      currentPage: 1,
      totalData: 0,
      formValues: {
        keyword: "",
        perPage: 5,
        izinKerja: "",
        jenis: "",
        wilayah: "",
        isKbli: false,
        kbli: "",
        keywordKbli: "",
        namaPjo: "",
        kompetensi: [],
        nilaiPraKplh: "",
        nilaiKplh: "",
        bidang: "",
        subbidang: "",
      },
      sortField: null,
      sortMethod: null,
      filtersInitialized: false,
    };
  },
  created() {
    this.initFiltersFromQuery();
  },
  mounted() {
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.formValues.keyword = q.keyword ?? "";
      this.formValues.izinKerja = q.izinKerja ?? "";
      this.formValues.jenis = q.jenis ?? "";
      this.formValues.wilayah = q.wilayah ?? "";
      this.formValues.kbli = q.kbli ?? "";
      this.formValues.keywordKbli = q.keywordKbli ?? "";
      this.formValues.namaPjo = q.namaPjo ?? "";
      if (q.kompetensi) {
        this.formValues.kompetensi = Array.isArray(q.kompetensi)
          ? q.kompetensi
          : q.kompetensi.split(",").filter(Boolean);
      } else {
        this.formValues.kompetensi = [];
      }
      this.formValues.nilaiPraKplh = q.nilaiPraKplh ?? "";
      this.formValues.nilaiKplh = q.nilaiKplh ?? "";
      this.formValues.bidang = q.bidang ?? "";
      this.formValues.subbidang = q.subbidang ?? "";

      if (q.page !== undefined && q.page !== "") {
        this.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.formValues.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        keyword: this.formValues.keyword?.trim() || undefined,
        izinKerja: this.formValues.izinKerja?.trim() || undefined,
        jenis: this.formValues.jenis || undefined,
        wilayah: this.formValues.wilayah || undefined,
        kbli: this.formValues.kbli?.trim() || undefined,
        keywordKbli: this.formValues.keywordKbli?.trim() || undefined,
        namaPjo: this.formValues.namaPjo?.trim() || undefined,
        kompetensi:
          this.formValues.kompetensi && this.formValues.kompetensi.length > 0
            ? this.formValues.kompetensi.join(",")
            : undefined,
        nilaiPraKplh: this.formValues.nilaiPraKplh?.trim() || undefined,
        nilaiKplh: this.formValues.nilaiKplh?.trim() || undefined,
        bidang: this.formValues.bidang?.trim() || undefined,
        subbidang: this.formValues.subbidang?.trim() || undefined,
        page: this.currentPage > 1 ? this.currentPage : undefined,
        perPage:
          this.formValues.perPage !== 5 ? this.formValues.perPage : undefined,
      };
      this.$router.replace({ query }).catch(() => {});
    },
    buildInfoKontraktorQuery() {
      const q = {};
      if (this.formValues.keyword?.trim()) q.keyword = this.formValues.keyword.trim();
      if (this.formValues.izinKerja?.trim()) q.izinKerja = this.formValues.izinKerja.trim();
      if (this.formValues.jenis) q.jenis = this.formValues.jenis;
      if (this.formValues.wilayah) q.wilayah = this.formValues.wilayah;
      if (this.formValues.kbli?.trim()) q.kbli = this.formValues.kbli.trim();
      if (this.formValues.keywordKbli?.trim()) q.keywordKbli = this.formValues.keywordKbli.trim();
      if (this.formValues.namaPjo?.trim()) q.namaPjo = this.formValues.namaPjo.trim();
      if (this.formValues.kompetensi && this.formValues.kompetensi.length > 0) {
        q.kompetensi = this.formValues.kompetensi.join(",");
      }
      if (this.formValues.nilaiPraKplh?.trim()) q.nilaiPraKplh = this.formValues.nilaiPraKplh.trim();
      if (this.formValues.nilaiKplh?.trim()) q.nilaiKplh = this.formValues.nilaiKplh.trim();
      if (this.formValues.bidang?.trim()) q.bidang = this.formValues.bidang.trim();
      if (this.formValues.subbidang?.trim()) q.subbidang = this.formValues.subbidang.trim();
      if (this.currentPage > 1) q.page = this.currentPage;
      if (this.formValues.perPage !== 5) q.perPage = this.formValues.perPage;
      return q;
    },
    onClearKeyword() {
      this.formValues.keyword = "";
      this.cariKontraktor();
    },
    closeModal() {
      const btn = document.getElementById("btnClose");
      if (btn) btn.click();
    },
    terapkan() {
      this.closeModal();
      this.cariKontraktor();
    },
    refresh() {
      this.formValues.keyword = "";
      this.formValues.izinKerja = "";
      this.formValues.jenis = "";
      this.formValues.wilayah = "";
      this.formValues.isKbli = false;
      this.formValues.kbli = "";
      this.formValues.keywordKbli = "";
      this.formValues.namaPjo = "";
      this.formValues.kompetensi = [];
      this.formValues.nilaiPraKplh = "";
      this.formValues.nilaiKplh = "";
      this.formValues.bidang = "";
      this.formValues.subbidang = "";
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.closeModal();
      this.syncFiltersToUrl();
      this.fetchData();
    },
    resetPaginasi() {
      this.kontraktors = [];
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.totalData = 0;
    },
    cariKontraktor() {
      this.resetPaginasi();
      this.syncFiltersToUrl();
      this.fetchData();
    },
    fetchData({ page, itemsPerPage, sortBy } = {}) {
      let val_lokal = null;
      let val_inti = null;
      if (this.formValues.wilayah != "") {
        val_lokal = this.formValues.wilayah == "lokal" ? true : false;
      }
      if (this.formValues.jenis != "") {
        val_inti = this.formValues.jenis == "inti" ? true : false;
      }

      if (this.formValues.kbli != "" || this.formValues.keywordKbli != "") {
        this.formValues.isKbli = true;
      } else {
        this.formValues.isKbli = false;
      }

      if (page) {
        this.currentPage = page;
        this.dataTable.pagination.page = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
        this.dataTable.pagination.itemsPerPage = itemsPerPage;
      }
      this.syncFiltersToUrl();

      let bodyJson = {
        header: {
          page: this.currentPage,
          perPage: this.formValues.perPage,
          usecase: "bebas",
        },
        lokal: val_lokal,
        inti: val_inti,
        isKbli: this.formValues.isKbli,
        kbli: this.formValues.kbli,
        keywordKbli: this.formValues.keywordKbli,
        namaPjo: this.formValues.namaPjo,
        kompetensiPjo: this.formValues.kompetensi,
        nilaiPraKplh: this.formValues.nilaiPraKplh,
        nilaiKplh: this.formValues.nilaiKplh,
        keyword: this.formValues.keyword,
        bidang: this.formValues.bidang,
        subBidang: this.formValues.subbidang,
        ob: sortBy ? sortBy[0]?.key : null,
        sort: sortBy ? sortBy[0]?.order : null,
      };
      this.dataTable.loading = true;
      axios
        .post(url, bodyJson)
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.countData;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.kontraktors = response.data.data;
          this.totalData = response.data.countData;
        })
        .catch((error) => {
          if (error.response?.status != 400) {
            alert("Error Fetch Data List Kontraktor : " + error.message);
            console.error("Error fetching data:", error);
          } else {
            this.kontraktors = [];
            this.totalData = 0;
          }
        })
        .finally(() => {
          this.dataTable.loading = false;
        });
    },
    redirectToLink(link, id) {
      this.$router.push({
        path: link + id,
        query: this.buildInfoKontraktorQuery(),
      });
    },
    parseWorkArea(raw) {
      // Handles both actual arrays and strings like "[Hauling, ROM]"
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        return raw.replace(/[[\]\s]/g, "").split(",");
      }
      return [];
    },
  },
  components: { SidebarLayout, NavbarLayout, FooterLayout },
  name: "infoKontraktor",
};
</script>
